import { render } from "./TargetsWard.vue?vue&type=template&id=7a98ba5d&scoped=true"
import script from "./TargetsWard.vue?vue&type=script&lang=js"
export * from "./TargetsWard.vue?vue&type=script&lang=js"

import "./TargetsWard.vue?vue&type=style&index=0&id=7a98ba5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a98ba5d"]])

export default __exports__